/**

 * Move theme breadcrumb pill tabs into #sefira-collection-top (after title).

 * Does NOT move the banner block — avoids layout jump.

 */

(function () {

  'use strict';



  function moveThemeTabsIntoTop() {

    var top = document.getElementById('sefira-collection-top');

    if (!top) return;



    if (top.querySelector('[data-sefira-tabs-from-breadcrumb]')) {

      top.dataset.sefiraTabsReady = '1';

      return;

    }



    var inline = top.querySelector('#sefira-inline-collection-tabs');

    if (inline && inline.querySelector('.sefira-collection-tab')) {

      top.dataset.sefiraTabsReady = '1';

      return;

    }



    var breadcrumbs = document.querySelector('.wpbingo-breadcrumbs');

    if (!breadcrumbs) return;



    var tabRoot = null;

    var carousels = breadcrumbs.querySelectorAll('.bwp_slider-carousel');

    for (var i = 0; i < carousels.length; i++) {

      if (carousels[i].querySelector('.item-collection')) {

        tabRoot = carousels[i];

        break;

      }

    }

    if (!tabRoot) {

      var slide = breadcrumbs.querySelector('.item-collection');

      if (slide) {

        tabRoot = slide.closest('.container') || slide.closest('.bwp-swiper-slider');

      }

    }

    if (!tabRoot) return;



    var mount = tabRoot.closest('.container') || tabRoot;

    if (top.contains(mount)) return;



    mount.setAttribute('data-sefira-tabs-from-breadcrumb', '1');

    mount.classList.add('sefira-collection-tabs-moved', 'sefira-collection-tabs-section');

    top.appendChild(mount);



    var section = breadcrumbs.closest('.shopify-section');

    if (section) {

      section.classList.add('sefira-breadcrumb-tabs-extracted');

    }



    top.dataset.sefiraTabsReady = '1';

  }



  moveThemeTabsIntoTop();

  document.addEventListener('DOMContentLoaded', moveThemeTabsIntoTop);

})();


